import { useContext } from 'react';
import { AuthContext } from '../../../context/AuthContext';
import { Navigate, useOutlet } from 'react-router-dom';
import { FAKE_AUTH_TOKEN } from '../../../constants';
import axios from 'axios';

export const ProtectedLayout = () => {
    const { user, isLoading } = useContext(AuthContext);
    const outlet = useOutlet();

    if (isLoading) {
        return null;
    }

    // Проверяем наличие пользователя и токена
    const hasAuth = FAKE_AUTH_TOKEN || (user && axios.defaults.headers.common['Authorization']);

    if (!hasAuth && !isLoading) {
        return <Navigate to="/login" replace />;
    }

    return <>{outlet}</>;
};
